import { Box, Card, Flex, Grid, Heading, Spinner, Text } from '@radix-ui/themes'
import CountUp from 'react-countup'
import useSWR from 'swr'

import { useGreetings } from '../hooks/useGreetings'
import { usePhrases } from '../hooks/usePhrases'

import { useAuth } from '@/hooks/useAuth'
import { getToken } from '@/utils/utils'
import { api } from '@/utils/api'

interface DashboardPayload {
  soldThisMonth: number
  unpublished: number
  published: number
  reserved: number
}

export const Dashboard = () => {
  const token = getToken() // FIXME: This could be implemented better...
  const { isLoading, data } = useSWR(token ? 'dashboard' : null, (url) => api.get<DashboardPayload>(url))
  const { phrase, nextPhrase } = usePhrases()
  const { greeting } = useGreetings()
  const { userData } = useAuth()

  const userName = userData?.user?.firstname ?? ''

  return (
    <Flex direction="column" gap="2" flexGrow="1">
      <Box>
        <Heading size="7">
          ¡{greeting}, {userName ?? ''}!
        </Heading>
        <Text size="3" mt="2" color="gray" onClick={nextPhrase}>
          {phrase}
        </Text>
      </Box>

      <Heading size="3" color="gray" mt="1">
        Vehículos
      </Heading>

      <Grid gap="4" columns="4">
        <Card>
          <Text size="1" color="gray">
            Publicados
          </Text>
          <Heading size="6" mt="1">
            {isLoading ? <Spinner /> : <CountUp end={data?.data?.published ?? 0} />}
          </Heading>
        </Card>

        <Card>
          <Text size="1" color="gray">
            Pendientes
          </Text>
          <Heading size="6" mt="1">
            {isLoading ? <Spinner /> : <CountUp end={data?.data?.unpublished ?? 0} />}
          </Heading>
        </Card>

        <Card>
          <Text size="1" color="gray">
            Reservados
          </Text>
          <Heading size="6" mt="1">
            {isLoading ? <Spinner /> : <CountUp end={data?.data?.reserved ?? 0} />}
          </Heading>
        </Card>

        <Card>
          <Text size="1" color="gray">
            Vendidos este mes
          </Text>
          <Heading size="6" mt="1">
            {isLoading ? <Spinner /> : <CountUp end={data?.data?.soldThisMonth ?? 0} />}
          </Heading>
        </Card>
      </Grid>
    </Flex>
  )
}
